import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "portfolio", label: "Portfólio" },
  { id: "sobre", label: "Sobre" },
  { id: "servicos", label: "Serviços" },
  { id: "instagram", label: "Instagram" },
  { id: "depoimentos", label: "Depoimentos" },
  { id: "contacto", label: "Contacto" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const ids = links.map((l) => l.id);
    const observers = ids.map((id) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const io = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveId(id); },
        { rootMargin: "-40% 0px -55% 0px" }
      );
      io.observe(el);
      return io;
    });
    return () => observers.forEach((io) => io?.disconnect());
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-sm border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-20 py-5 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-heading text-white text-xl tracking-[0.25em] hover:text-[#c0392b] transition-colors"
          data-testid="nav-logo"
        >
          MIGUEL FARIA<span className="text-[#c0392b]">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className={`nav-link font-heading text-sm tracking-[0.25em] uppercase ${activeId === l.id ? "text-[#c0392b]" : ""}`}
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile full-screen overlay */}
      <div
        className={`md:hidden fixed inset-0 z-40 bg-black flex flex-col justify-center px-8 transition-all duration-500 ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        data-testid="nav-mobile-menu"
      >
        <div className="flex items-center gap-3 mb-12">
          <span className="divider-red" />
          <span className="font-heading text-[#c0392b] tracking-[0.4em] text-xs uppercase">Menu</span>
        </div>
        <div className="flex flex-col gap-2">
          {links.map((l, i) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="font-heading text-white text-5xl uppercase tracking-[-0.01em] text-left hover:text-[#c0392b] transition-colors duration-200 py-2 border-b border-white/10"
              style={{ transitionDelay: open ? `${i * 50}ms` : "0ms", transform: open ? "translateX(0)" : "translateX(-20px)", transition: `color 200ms, transform 400ms ${i * 50}ms, opacity 400ms ${i * 50}ms`, opacity: open ? 1 : 0 }}
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>
        <div className="mt-16 flex gap-6 text-white/40 text-xs font-heading tracking-[0.3em] uppercase">
          <span>@miguelfaria.photo</span>
        </div>
      </div>
    </header>
  );
};

export default Nav;
